import type { IEndpointOAuth2Authentication } from '@deity-io/di-data-flows';
import { Input } from '@deity-io/portal-ui';
import type { FC } from 'react';

interface IAuthorizationProps {
  isEditable: boolean;
  authentication?: Partial<IEndpointOAuth2Authentication>;
  parent?: Partial<IEndpointOAuth2Authentication>;
  onChange: (key: string[], value: any | null, set?: boolean) => void;
}

const Oauth2Authentication: FC<IAuthorizationProps> = ({ isEditable, authentication, parent, onChange }) => (
  <>
    <Input
      label={!authentication?.tokenUrl && parent?.tokenUrl ? `${parent?.tokenUrl} (inherited)` : 'Token URL'}
      type="text"
      name="token-url"
      id="token-url"
      value={(authentication as IEndpointOAuth2Authentication)?.tokenUrl}
      onChange={e => onChange(['authentication', 'tokenUrl'], e.target.value)}
      placeholder="Enter token URL"
      disabled={!isEditable}
      sx={{ marginY: 2 }}
      autoComplete="off"
    />
    <Input
      label={!authentication?.clientId && parent?.clientId ? `${parent?.clientId} (inherited)` : 'Client ID'}
      type="text"
      name="client-id"
      id="client-id"
      value={(authentication as IEndpointOAuth2Authentication)?.clientId}
      onChange={e => onChange(['authentication', 'clientId'], e.target.value)}
      placeholder="Enter client ID"
      disabled={!isEditable}
      sx={{ marginY: 2 }}
      autoComplete="off"
    />
    <Input
      label={!authentication?.clientSecret ? `***** (inherited)` : 'Client Secret'}
      type="password"
      name="client-secret"
      id="client-secret"
      value={(authentication as IEndpointOAuth2Authentication)?.clientSecret}
      onChange={e => onChange(['authentication', 'clientSecret'], e.target.value)}
      placeholder="Enter client secret"
      disabled={!isEditable}
      sx={{ marginY: 2 }}
      autoComplete="off"
    />
  </>
);

export default Oauth2Authentication;
